import Model from '../../Helper/Model';

export enum EventType {
    STATE_CHANGED = 'TABLE_STATE_CHANGED',
    NEW_EVENT_RECEIVED = 'NEW_EVENT_RECEIVED',
}

export default abstract class StateModel extends Model {
    public static readonly EVENT_TYPE = EventType;

    /**
     * The current state of the state model, used to synchronize with state scenarios
     */
    public abstract get state(): string;
    protected abstract set state(s: string);
    /**
     * The current round ID of the state model, used to identify different rounds of the state model
     */
    public abstract get roundID(): number;
    protected abstract set roundID(r: number);
}
